import React, { useState } from 'react';
import { CLOSE_REWARD_SVG, ERROR_MESSAGE } from '../staticTypes'

const Error = (props) => {
	
	const { email } = props;
	const { points } = props.data;
	const [closeErrorFlag, setCloseErrorFlag] = useState(false)
	const closeError = () => {
		setCloseErrorFlag(true)
	}

	return (
		<div className={`reward-error ${closeErrorFlag === false && email !== '' && points === undefined ? 'show' : 'hide'}`}>
			<div className="error-title">{ERROR_MESSAGE}</div>
			<div className="close-error" onClick={closeError}>
				{CLOSE_REWARD_SVG}
			</div>
		</div>
	);
}

export default Error;